import "./App.css";
import "./yovai-home.css";
import "./yovai-premium.css";
import "./yovai-ops.css";
import { captureSource } from "./lib/source";
import ApplicationReceived from "./pages/ApplicationReceived";
import Admin from "./pages/Admin";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import SmsTerms from "./pages/SmsTerms";
import CancellationRefunds from "./pages/CancellationRefunds";
import Support from "./pages/Support";
import Safety from "./pages/Safety";
import DPA from "./pages/DPA";
import PilotCheckoutSuccess from "./pages/PilotCheckoutSuccess";
import PilotCheckoutCancel from "./pages/PilotCheckoutCancel";

captureSource();

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/application-received" element={<ApplicationReceived />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/sms-terms" element={<SmsTerms />} />
          <Route path="/cancellation-refunds" element={<CancellationRefunds />} />
          <Route path="/support" element={<Support />} />
          <Route path="/dental" element={<Navigate to="/#industries" replace />} />
          <Route path="/safety" element={<Safety />} />
          <Route path="/dpa" element={<DPA />} />
          <Route path="/pilot-checkout/success" element={<PilotCheckoutSuccess />} />
          <Route path="/pilot-checkout/cancel" element={<PilotCheckoutCancel />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
